import { alpha } from "@mui/material/styles";
import palette from "./palette";

// ----------------------------------------------------------------------
// Only shadows referenced by the app / component overrides.
// ----------------------------------------------------------------------

const color = palette.grey[500];

export default function customShadows() {
  const transparent = alpha(color, 0.16);
  const actionGlow = `0 8px 16px 0 ${alpha(palette.secondary.main, 0.24)}`;

  return {
    z1: `0 1px 2px 0 ${transparent}`,
    z4: `0 4px 8px 0 ${transparent}`,
    z8: `0 8px 16px 0 ${transparent}`,
    z20: `0 20px 40px -4px ${transparent}`,
    // CTA glow (bright blue)
    primary: actionGlow,
    secondary: actionGlow,
    card: `0 0 2px 0 ${alpha(color, 0.2)}, 0 12px 24px -4px ${alpha(color, 0.12)}`,
  };
}
